enum ProviderProfileSource {
  Npi = 'Npi',
  Caqh = 'Caqh',
  CaqhPo = 'CaqhPo',
  AmericanMedicalAssociationPhysician = 'AmericanMedicalAssociationPhysician',
  AmericanMedicalAssociationPhysicianAssistant = 'AmericanMedicalAssociationPhysicianAssistant'
}

export const MapProviderProfileTypeLabel: ObjectType<string> = {
  [ProviderProfileSource.Caqh]: 'CAQH',
  [ProviderProfileSource.CaqhPo]: 'CAQH PO',
  [ProviderProfileSource.AmericanMedicalAssociationPhysician]:
    'American Medical Association Physician',
  [ProviderProfileSource.AmericanMedicalAssociationPhysicianAssistant]:
    'American Medical Association Physician Assistant'
};

export const ProviderProfileSourceLabel: ObjectType<string> = {
  [ProviderProfileSource.Caqh]: 'CAQH ProView',
  [ProviderProfileSource.CaqhPo]: 'CAQH Participating Organization',
  [ProviderProfileSource.AmericanMedicalAssociationPhysician]: 'American Medical Association',
  [ProviderProfileSource.AmericanMedicalAssociationPhysicianAssistant]:
    'American Medical Association'
};

export const ProviderProfileSourceFormUILabel: ObjectType<string> = {
  [ProviderProfileSource.AmericanMedicalAssociationPhysician]: 'Physician',
  [ProviderProfileSource.AmericanMedicalAssociationPhysicianAssistant]: 'Physician Assistant'
};

export const AmaProfileSources = [
  ProviderProfileSource.AmericanMedicalAssociationPhysician,
  ProviderProfileSource.AmericanMedicalAssociationPhysicianAssistant
];

export const getAmaSourceAsList = (): CommonList[] => {
  return AmaProfileSources.map((source: ProviderProfileSource) => ({
    id: source,
    label: ProviderProfileSourceFormUILabel[source]
  }));
};

export default ProviderProfileSource;
